/**
 * SEO Constants
 * Page-specific SEO configurations
 */

export const DEFAULT_SEO = {
  siteName: "MerchMidas",
  title: "MerchMidas - AI-Powered Visual Merchandising Suite",
  description: "Premium AI-powered visual merchandising suite for e-commerce. Virtual try-ons, product staging, ad generation, and more.",
  image: "/og-image.png",
  url: "https://merchmidas.com",
  twitterHandle: "@merchmidas",
  keywords: [
    "AI",
    "visual merchandising",
    "e-commerce",
    "virtual try-on",
    "product staging",
    "ad generator",
    "merchandising tools",
  ],
};

// Pre-defined SEO configs for each page
export const PAGE_SEO = {
  landing: {
    title: undefined, // Uses default
    description: "Transform your e-commerce with AI-powered visual merchandising. Virtual try-ons, professional product staging, and dynamic ad creation.",
  },
  pricing: {
    title: "Pricing",
    description: "Choose the perfect plan for your business. Start free with 100 credits, or unlock unlimited potential with Pro and Business plans.",
  },
  dashboard: {
    title: "Dashboard",
    description: "Access your AI merchandising tools and manage your projects.",
    noIndex: true,
  },
  tryOn: {
    title: "Virtual Try-On Studio",
    description: "AI-powered virtual fitting room. Let customers see how your products look on them before they buy.",
  },
  staging: {
    title: "Product Staging Pro",
    description: "Professional AI product photography. Create stunning catalog-ready images in seconds.",
  },
  ads: {
    title: "AI Ad Creative Generator",
    description: "Generate high-converting ad creatives with AI. Multi-platform formats, A/B testing ready.",
  },
  designer: {
    title: "Personalized Gift Designer",
    description: "Create custom gift products with AI. Personalization at scale for your customers.",
  },
  visualizer: {
    title: "AR Furniture Visualizer",
    description: "Let customers visualize furniture in their space with augmented reality.",
  },
  unboxing: {
    title: "AI Unboxing Video Creator",
    description: "Generate engaging unboxing videos with AI. Perfect for social media and product launches.",
  },
  billing: {
    title: "Billing & Subscription",
    description: "Manage your subscription, credits, and payment methods.",
    noIndex: true,
  },
  privacy: {
    title: "Privacy Policy",
    description: "Learn how MerchMidas protects and handles your data.",
  },
  terms: {
    title: "Terms of Service",
    description: "Terms and conditions for using MerchMidas services.",
  },
  cookies: {
    title: "Cookie Policy",
    description: "How MerchMidas uses cookies to improve your experience.",
  },
};
